import React from 'react';
import {
  Content,
  Container,
  EventInformation,
  DataContainer,
  MediaWrapper,
  MediaImageWrapper,
  MediaTextWrapper,
} from 'app/components/matchEvents/MatchEventStyles';
import {COLORS, Button, Typography, Image} from '@fupa/fupa-uikit';
import {LinkOnComponent} from 'app/components/links/link';
import PropTypes from 'prop-types';
import {CustomLinkContainer} from 'app/components/match/matchLive/tickerStreamElementStyles';
import {PhotoLibrary} from '@mui/icons-material';

const TickerGalleryUploaded = ({gallery}) => {
  return (
    <LinkOnComponent to={`/photos/${gallery.slug}`}>
      <Content>
        <Container>
          <EventInformation customBgColor={COLORS.deepBlue}>
            <PhotoLibrary style={{color: COLORS.white, fontSize: 20}} />
          </EventInformation>
          <DataContainer>
            <Typography variant='body1'>Neue Fotos hochgeladen! 🖼</Typography>
            <MediaWrapper>
              <MediaTextWrapper>
                <Typography variant='body2'>{gallery.title}</Typography>
                <CustomLinkContainer>
                  👉 <Button label='Jetzt ansehen' text />
                </CustomLinkContainer>
              </MediaTextWrapper>
              <MediaImageWrapper>
                <Image entity='gallery' ratio='1:1' width={64} height={64} src={gallery.thumbnail.image} />
              </MediaImageWrapper>
            </MediaWrapper>
          </DataContainer>
        </Container>
      </Content>
    </LinkOnComponent>
  );
};

TickerGalleryUploaded.propTypes = {
  gallery: PropTypes.object.isRequired,
};

export default TickerGalleryUploaded;
